<div class="mt-8 px-4">
    <div *ngIf="channel != null">

        <div class="flex flex-row items-center justify-end w-full gap-4">

            <!-- <button (click)="refreshChannel()"
                    class="bg-primary-500 active:bg-secondary-500 hover:bg-primary-300 uppercase text-white font-bold hover:shadow-lg shadow text-sm px-4 py-4 rounded outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>Refresh
                </button> -->
            <button [routerLink]="['edit']"
                class="bg-primary-500 active:bg-secondary-500 hover:bg-primary-300 text-white hover:shadow-lg shadow text-sm font-bold uppercase px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"><i class="fa fa-edit mr-2 leading-relaxed"></i>Edit
            </button>

            <!-- <button (click)="deleteChannel()"
                    class="bg-red-500 active:bg-secondary-500 hover:bg-secondary-500 uppercase text-white font-bold hover:shadow-lg shadow text-sm px-4 py-3 rounded outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                    type="button"><i class="fa fa-trash-alt mr-2 leading-relaxed"></i>Delete
                </button> -->
        </div>

        <div class="relative break-words bg-white w-full mt-24 mb-8 shadow-xl rounded-lg">

            <div class="flex flex-col w-full">
                <div class="w-full px-auto grid grid-rows-1 place-items-center -mt-16">
                    <!-- <div class=" -mt-16"> -->
                    <img *ngIf="channel.imageUrl" alt="Channel Image" [src]="channel.imageUrl"
                        class="shadow-xl rounded h-auto sm:w-auto align-middle border-none max-w-150-px" />
                    <div *ngIf="!channel.imageUrl" class="bg-primary-100 h-36 w-36 max-w-150-px rounded"></div>
                    <!-- </div> -->
                </div>
                <div class="text-center mt-8">
                    <h3 class="text-4xl font-semibold leading-normal mb-2 text-blueGray-700">
                        {{channel.name}}
                    </h3>
                    <div class="text-sm leading-normal mt-2 mb-2 text-blueGray-400 font-bold">
                        {{channel.createdBy}}
                    </div>
                </div>
                <div class="mt-2 p-4 border-t border-blueGray-200 text-center">
                    <div class="flex flex-wrap justify-center">
                        <div class="w-full lg:w-9/12 px-4">
                            <p class="mb-4 text-sm leading-relaxed whitespace-pre-line text-blueGray-700">
                                {{channel.description}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="channel == null" class="relative text-lg text-primary-300 py-16">
        <h1 class="text-6xl font-bold text-primary-500 mb-8 ">Create Your Channel !!</h1>
        <p class="mb-4">We couldn't find a Channel registered in your name.</p>
        <p class="mb-4">Create a new channel by clicking the 'Create Channel' button below.</p>
        <p class="mb-8">Or, if you are certain of already having a channel, then kindly refresh the page to fetch
            channel details.
        </p>

        <div class="flex justify-start">
            <button [routerLink]="['../channel/create']" routerLinkActive="router-link-active"
                class="bg-secondary-500 active:bg-primary-500 hover:bg-secondary-700 uppercase text-white font-bold hover:shadow-lg shadow text-sm px-4 py-4 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                type="button"><i class="fa fa-add mr-2 leading-relaxed"></i>Create Channel
            </button>
            <button (click)="refreshChannel()"
                class="bg-primary-500 active:bg-secondary-500 hover:bg-primary-300 uppercase text-white font-bold hover:shadow-lg shadow text-sm px-4 py-4 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                type="button"><i class="fa fa-refresh mr-2 leading-relaxed"></i>Refresh Channel
            </button>
        </div>
    </div>
</div>